import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ImportFatturePassiveModalComponent } from './import-fatture-passive-modal';

export const ImportFatturePassiveModalModule: string = ng
    .module('archiSmall.components.importFatturePassiveModalModule', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('importFatturePassiveModalComponent', ImportFatturePassiveModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/import-fatture-passive-modal/import-fatture-passive-modal.module.ts